import { all, call, CallEffect, fork, put, PutEffect, takeEvery } from "redux-saga/effects";
import { fetchStickySuccess } from "../actions/Notes";
import { ActionTypes } from "../../constants/ActionTypes";
import { ShowError } from "../../helper/Alert";

const stickeis: string[] = [];
const getSticky = async () => stickeis;

function* fetchStickyRequest(): Generator<CallEffect<string[]> | PutEffect<{ type: ActionTypes; payload: any; }>, void, void> {
  try {
    const fetchedSticky = yield call(getSticky);
    yield put(fetchStickySuccess(fetchedSticky));
  } catch (error) {
    return ShowError("", error);
  }
}

export function* fetchSticky() {
  yield takeEvery(ActionTypes.GET_STICKY, fetchStickyRequest);
}

export function* updateSticky() {
  yield takeEvery(ActionTypes.GET_STICKY, fetchStickyRequest);
}

export default function* rootSaga() {
  yield all([fork(fetchSticky), fork(updateSticky)]);
}
